<section id="wrapper" class="login-register login-sidebar" style="background-image:url(././../assets/images/login-register.jpg);background-size: cover;">
  <div class="login-box card">
      <div class="card-body">
          <form class="form-horizontal form-material text-center" id="loginform" [formGroup]="LoginForm">
              <a href="javascript:void(0)" class="db"><img src="././../assets/images/hub.png" alt="Home" priority /></a>
              <div class="form-group m-t-40">
                  <div class="col-xs-12">
                      <input class="form-control" type="text"  formControlName="email"
                      [(ngModel)]="loginObj.email" placeholder="Username">
                  </div>
                  <div class="error" *ngIf="LoginForm.controls['email'].hasError('email')">Provide a valid email.
                </div>
                <div class="error" *ngIf="LoginForm.controls['email'].hasError('required') && LoginForm.controls['email'].touched">Please provide an email
                  address</div>
              </div>
              <div class="form-group">
                  <div class="col-xs-12">
                      <input class="form-control" type="password" formControlName="password"
                      [(ngModel)]="loginObj.password"  placeholder="Password">
                  </div>

                  <div class="error"
                  *ngIf="LoginForm.controls['password'].hasError('required') && LoginForm.get('password').touched">
                  Please enter new password</div>

                <div class="error"
                  *ngIf="LoginForm.controls['password'].hasError('minlength') && LoginForm.get('password').touched">
                  Please enter a new password at least 8 characters.</div>

                <div class="error"
                  *ngIf="LoginForm.controls['password'].hasError('maxlength') && LoginForm.get('password').touched">
                  Please enter a new password no more than 16 characters.</div>


                <div class="error"
                  *ngIf="LoginForm.controls['password'].hasError('pattern') && LoginForm.get('password').touched">
                  Must contain at least one number and one uppercase and special character</div>

              </div>
              <div class="form-group row">
                  <div class="col-md-12">
                      <div class="d-flex no-block align-items-center">
                          <div class="ms-auto">
                              <a (click)="forgotPassword()" id="to-recover" class="text-muted cursor"><i class="fas fa-lock m-r-5"></i> Forgot password?</a>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="form-group text-center m-t-20">
                  <div class="col-xs-12">
                      <button class="btn bg-info  btn-lg w-100 text-uppercase btn-rounded text-white" type="submit" (click)="login()">Log In</button>
                  </div>
              </div>

          </form>
      </div>
  </div>
</section>
